import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DgkState = {
  data: any | null;
};

const initialState: DgkState = {
  data: null,
};

const dgkSlice = createSlice({
  name: "dgk",
  initialState,
  reducers: {
    setDgkData(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
    resetDgkData(state) {
      state.data = null;
    },
  },
});

export const { setDgkData, resetDgkData } = dgkSlice.actions;
export default dgkSlice.reducer;